<template>
  <v-container class="ma-0">
    <v-row>
      <v-col class="shrink">
        <v-card class="stick">
        <v-navigation-drawer right floating dark color="secondary darken-1" permanent class="mt-14 text--primary">
          <v-list>
            <v-list-item>
              <v-list-item-title class="text-center primary--text">
                <h1>Contents</h1>
              </v-list-item-title>
            </v-list-item>
          </v-list>
          <v-divider />
          <v-list>
            <v-list-item v-for="bookmark in bookMarks" :key="bookmark.id"  @click="toBookmark(bookmark.id)" >
              <v-list-item-icon class="mr-2">
              <v-icon>
                mdi-checkbox-blank-circle
              </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="primary--text">
                  {{ bookmark.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider />
            <v-list>
              <v-list-item to="/#">
                <v-list-item-icon class="mr-2">
                  <v-icon>mdi-file-pdf</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="primary--text">
                    Printable version
                  </v-list-item-title>
                  <v-list-item-subtitle class="grey--text text--darken-1">
                    Download printable pdf file
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
        </v-navigation-drawer>
        </v-card>
      </v-col>
      <v-col cols="8">
        <component :is="videoDescription" ref="pageItem"/>
        <v-btn
            v-show="showScrollTop"
            fab
            dark
            fixed
            right
            bottom
            v-scroll="onScroll"
            @click="$vuetify.goTo(0)"
        >
          <v-icon color="primary">mdi-chevron-up</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Video1 from '@/views/tutorials/Video1'
import NotFound from './tutorials/NotFound'
import Video2 from '@/views/tutorials/Video2'
import Video3 from '@/views/tutorials/Video3'
export default {
  name: 'Video',
  data: () => ({
    items: {
      video1: Video1,
      video2: Video2,
      video3: Video3
    },
    showScrollTop: false
  }),
  computed: {
    videoDescription () {
      return  this.items[this.$route.params.id] || NotFound
    },
    bookMarks () {
      return this.videoDescription.methods.bookMarks()
    },
    part () {
      return this.$route.query.to
    }
  },
  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.showScrollTop = top > 20
    },
    toBookmark(id) {
      this.$vuetify.goTo(id)
      setTimeout(() => {
        this.$vuetify.goTo(id)
      }, 500)
      setTimeout(() => {
       this.$vuetify.goTo(id)
      }, 1000)
      setTimeout(() => {
        this.$vuetify.goTo(id)
      }, 1500)
      setTimeout(() => {
        this.$vuetify.goTo(id)
      }, 2000)
    }
  },
  mounted() {
    if (this.part) {
      this.toBookmark('#' + this.part)
    }
  },
  watch: {
    part () {
      if (this.part) {
        console.log(this.part)
        setTimeout(() => {
          this.toBookmark('#' + this.part)
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>
.stick {
  position: -webkit-sticky;
  position: sticky;
  top: 5rem;
}
</style>